module.exports = __webpack_public_path__ + "static/media/telegram-darkmode.e80f8b50.svg";